/**
 * LLMコストAPIクライアント
 */

import { AuthenticatedApiClient } from '../client';
import type { LlmCostResponse } from '@/lib/types/mise/llmCost';

/**
 * LLMコストを取得（認証付き）
 */
export async function getLlmCostAuthenticated(
  authHeaders: Record<string, string>,
  params: {
    start_date: string;
    end_date: string;
    account_code?: string;
  },
): Promise<LlmCostResponse> {
  try {
    const client = new AuthenticatedApiClient(authHeaders);
    const queryParams = new URLSearchParams();
    queryParams.append('start_date', params.start_date);
    queryParams.append('end_date', params.end_date);
    if (params.account_code) {
      queryParams.append('account_code', params.account_code);
    }

    const url = `/mise/llm-cost?${queryParams.toString()}`;
    const data = await client.get<LlmCostResponse>(url);
    return data;
  } catch (error) {
    console.error('Failed to fetch LLM cost:', error);
    throw error;
  }
}
